// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__RbymG","detailsBorder":"styles_detailsBorder__1iE3V"};